// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CodepenCircleOutlinedSvg from "@fishx/icons-svg/es/asn/CodepenCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var CodepenCircleOutlined = function CodepenCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CodepenCircleOutlinedSvg
  }));
};

CodepenCircleOutlined.displayName = 'CodepenCircleOutlined';
export default React.forwardRef(CodepenCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CodepenCircleOutlined.js
// module id = 2282
// module chunks = 0